export enum InformationType {
    Legal = 'legal',
    Location = 'location',
    Management = 'management'
}

export enum Operation {
    PUT = 'put',
    DELETE = 'delete'
}
